import React, { useEffect, useState } from 'react';
import Text from '../../../shared/common/Text';
import { AutocompleteStyled, CenterSearchMember, ContainerGroupsForm } from '../styled-components/groups.styled.components';
import { TextField } from '@material-ui/core';

const SelectLeader = props => {
    const { participants, setLider, initialValue, placeholder } = props;

    const [value, setValue] = useState(initialValue);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (value !== null) {
            setLider(value.participante_id);
        }
    }, [value, inputValue]);



    // RETURN
    return (
        <ContainerGroupsForm>
            <Text fontSize="1rem" fontWeight="700" color="primary">
                Líder de grupo
            </Text>
            <CenterSearchMember>
                <AutocompleteStyled
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue )
                            // ? newValue?.participante_id : null);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    id="leader"
                    options={participants}
                    getOptionLabel={option => option.nombre}
                    renderInput={params => (
                        <TextField {...params} label="" placeholder={placeholder} variant="outlined" required style={{ width: '100%' }} />
                    )}
                />
            </CenterSearchMember>
        </ContainerGroupsForm>
    );
};

export default SelectLeader;
